import { createContext } from 'react';

const ErrorMessageContext = createContext({
  errorMessages: [],
  showErrorMessage: false,
  addErrorMessage: () => {},
  clearErrorMessages: () => {},
});

export default ErrorMessageContext;